import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getOrderById } from "../../api/apiOrders";

export const useGetOrderById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["order", id, i18next.language],
        queryFn: () => getOrderById(id),
        enabled: !!id,
        retry: false,
    });

    return {
        order: data?.data || null,
        isLoading,
        error,
        refetch,
    };
};
